import { render, staticRenderFns } from "./materials.vue?vue&type=template&id=19c7a7da&scoped=true&"
import script from "./materials.vue?vue&type=script&lang=js&"
export * from "./materials.vue?vue&type=script&lang=js&"
import style0 from "./materials.vue?vue&type=style&index=0&id=19c7a7da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c7a7da",
  null
  
)

export default component.exports